<template>
  <div class="bc-placeholders">
    <span class="bc-placeholders__label">Variáveis</span>
    <span v-for="item in items" :key="item.token"
          class="bc-placeholder" role="button" tabindex="0" draggable="true"
          :title="item.label + ' — arraste para o texto ou clique para inserir'"
          @dragstart="onDragStart($event, item.token)"
          @mousedown.prevent
          @click="$emit('insert', item.token)"
          @keydown.enter.prevent="$emit('insert', item.token)">{{ item.token }}</span>
    <span class="bc-placeholders__hint">Trocado pelo primeiro nome de quem vê o aviso.</span>
  </div>
</template>

<script>
import { BROADCAST_PLACEHOLDERS } from './broadcastPlaceholders';

/**
 * Chips de marcador, como os de "Modelos de termo" do Inventario.
 *
 * Arrastar usa `text/plain` de proposito: input e o editor (Quill, que e
 * contenteditable) ja sabem soltar texto no ponto exato onde o mouse soltou,
 * e o Quill trata isso como edicao da pessoa. Clicar insere no ultimo cursor
 * conhecido — o `mousedown.prevent` impede o chip de roubar o foco antes.
 */
export default {
  name: 'placeholder-chips',
  data() {
    return { items: BROADCAST_PLACEHOLDERS };
  },
  methods: {
    onDragStart(event, token) {
      event.dataTransfer.setData('text/plain', token);
      event.dataTransfer.effectAllowed = 'copy';
    },
  },
};
</script>

<style scoped>
.bc-placeholders { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin: 0 0 12px; }
.bc-placeholders__label { font-size: 12px; font-weight: 600; color: #3a424e; }
.bc-placeholder {
  display: inline-flex; align-items: center; padding: 2px 10px; border-radius: 999px;
  background: #eef3ff; border: 1px solid #c7d6fe; color: #1b59f8; font-size: 12px;
  font-family: monospace; cursor: grab; user-select: none;
}
.bc-placeholder:active { cursor: grabbing; }
.bc-placeholders__hint { font-size: 12px; color: #4e5560; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/broadcast/placeholderChips.vue